import React from 'react';
import { UserProfile, Client } from '@/shared/types';
import { VARIANT_CONFIG } from '@/features/templates/components/CorporateSuite/configs/variantConfigs';
import { SidebarLeftComponent, SidebarRightComponent } from '@/features/templates/components/CorporateSuite/components/SidebarComponent';
import { MainContent } from '@/features/templates/components/CorporateSuite/components/MainContent';
import { renderHeader } from '@/features/templates/components/CorporateSuite/utils/headerRenderer';

interface TemplateProps {
  profile: UserProfile;
  client?: Client | null;
  title: string;
  metaData: { label: string; value: string }[];
  children: React.ReactNode;
  footerNote?: string;
  type: string;
  containerClass: string;
  LogoImage: React.FC<{ size: 'sm' | 'md' | 'lg' | 'xl'; className?: string; light?: boolean }>;
  variant: string;
  hideHeader?: boolean;
}

const CorporateSuite: React.FC<TemplateProps> = ({
  profile, client, title, metaData, children, footerNote, type, containerClass, LogoImage, variant, hideHeader = false
}) => {
  const config = VARIANT_CONFIG[variant] || VARIANT_CONFIG['corp-alpha'];

  const fontClass = config.font === 'serif' ? 'font-serif' : config.font === 'mono' ? 'font-mono' : 'font-sans';

  const headerProps = {
    profile,
    title,
    type,
    metaData,
    config,
    LogoImage
  };

  const mainContentProps = {
    profile,
    client: client || null,
    metaData,
    footerNote: footerNote || '',
    config,
    LogoImage,
    type,
    children
  };

  return (
    <div className={`${containerClass} ${fontClass} bg-${config.bg} relative flex flex-col md:flex-row`}>
      {/* Sidebar Layout Handling */}
      {['sidebar-left', 'sidebar-right', 'dark-sidebar'].includes(config.header) ? (
        <>
          {!hideHeader && config.header !== 'sidebar-right' && (
            <SidebarLeftComponent {...headerProps} />
          )}

          <MainContent {...mainContentProps} />

          {!hideHeader && config.header === 'sidebar-right' && (
            <SidebarRightComponent {...headerProps} />
          )}
        </>
      ) : (
        <div className="w-full h-full flex flex-col">
          {!hideHeader && renderHeader(headerProps)}
          <MainContent {...mainContentProps} />
        </div>
      )}
    </div>
  );
};

export default CorporateSuite;